import { j as r } from "../../../../jsx-runtime-B6kdoens.js";
import { useContext as p } from "react";
import { b as x, a as d } from "../../../../index-CROKJrb5.js";
import { c as C, f as g } from "../../../../create-component-CBAeEoQ6.js";
import { CardTitle as j } from "../../CardTitle/index.js";
import { C as h } from "../../../../CardContext-B6h__heb.js";
import { BeforeAfterCardMeta as v } from "../BeforeAfterCardMeta/index.js";
const b = x({
  base: "cur-flex cur-grow cur-flex-col cur-gap-2 cur-p-1",
  variants: {
    surface: {
      transparent: "cur-p-2",
      white: null
    }
  }
}), E = C(
  "BeforeAfterCardContent",
  g(
    ({
      as: c,
      children: o,
      className: t,
      images: a = null,
      meta: e = null,
      rating: n = null,
      tags: l = null,
      title: s = null,
      ...u
    }, f) => {
      const m = c || "div", { surface: i } = p(h);
      return /* @__PURE__ */ r.jsxs(
        m,
        {
          className: d("cur-flex cur-grow cur-flex-col cur-gap-2", t),
          ref: f,
          ...u,
          children: [
            /* @__PURE__ */ r.jsxs("div", { className: "cur-flex cur-grow cur-flex-col cur-items-start cur-gap-2", children: [
              a,
              /* @__PURE__ */ r.jsxs(
                "div",
                {
                  className: b({
                    surface: i,
                    className: t
                  }),
                  children: [
                    typeof s == "string" ? /* @__PURE__ */ r.jsx(j, { children: s }) : s,
                    typeof e == "string" ? /* @__PURE__ */ r.jsx(v, { children: e }) : e,
                    n,
                    o ? /* @__PURE__ */ r.jsx("div", { className: "cur-mb-4 [&_p]:cur-mb-2 last:[&_p]:cur-mb-0", children: o }) : null
                  ]
                }
              )
            ] }),
            l
          ]
        }
      );
    }
  )
);
export {
  E as BeforeAfterCardContent
};
//# sourceMappingURL=index.js.map
